import type { DateString } from '../../core/types/dates.js';

/**
 * Props for the TimeseriesChart.XAxis slot component props
 * @public
 */
export interface TimeseriesChartXAxisProps {
  /** The maximum point in time for the X axis.
   * It can either be:
   * a number representing a timestamp,
   * an ISO8601-compliant string,
   * or a Date object
   */
  max?: number | DateString | Date;
  /** The minimum point in time for the X axis.
   * It can either be:
   * a number representing a timestamp,
   * an ISO8601-compliant string,
   * or a Date object
   */
  min?: number | DateString | Date;
  /** The label to display alongside the axis. */
  label?: string;
}

/**
 * @public
 */
export const XAxis = (props: TimeseriesChartXAxisProps) => null;

XAxis['displayName'] = 'TimeseriesChart.XAxis';
